export function claimPending(ref) {
  if (ref.current) return false
  // eslint-disable-next-line no-param-reassign
  ref.current = true
  return true
}
